import React from "react";
import { HostGameContext } from "./HostGameContext";

export const useHostGame = () => {
  return React.useContext(HostGameContext);
};

export * from "./HostGameProvider";
